import type { QueryGiftCardConfig } from '@common/api/graphql/getProjectsGql';
import type { StyleRules, WithStyles } from '@mui/styles';
import withStyles from '@mui/styles/withStyles';
import TicketTypeChip, { getGiftCardTicketType } from './TicketTypeChip';

const styles = (): StyleRules => ({});

type TicketTypeChipsOwnProps = {
  giftCardConfig: QueryGiftCardConfig;
};

type TicketTypeChipsProps = TicketTypeChipsOwnProps & WithStyles<typeof styles>;

const TicketTypeChips: React.FC<TicketTypeChipsProps> = ({
  giftCardConfig
}) => (
  <div data-cy={`ticketTypeChips-${giftCardConfig.urlCode}`}>
    {giftCardConfig.giftCardTicketConfigs.map(
      (giftCardTicketConfig, giftCardTicketConfigIndex) => (
        <TicketTypeChip
          key={`ticketTypeChip-${giftCardConfig.urlCode}-${giftCardTicketConfigIndex}`}
          ticketType={getGiftCardTicketType(giftCardTicketConfig)}
        />
      )
    )}
  </div>
);

export default withStyles(styles)(TicketTypeChips);
